module.exports = __webpack_public_path__ + "static/media/GalleryImage09.b735b1d4.jpg";